import { articles } from "@/mocks/homeData";

export default function ArticleSection() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="flex items-center gap-2">
            <i className="ri-eye-line text-primary-500 text-lg"></i>
            <h2 className="text-lg md:text-xl font-bold text-foreground-950">
              ママが今見ている記事
            </h2>
          </div>
          <a
            href="#"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1"
          >
            もっと見る
            <i className="ri-arrow-right-s-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {articles.map((article) => (
            <a
              key={article.id}
              href="#"
              className="group bg-white rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-3">
                <p className="text-xs text-foreground-500 mb-1">{article.views}</p>
                <p className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}